import React from "react";
import { AttackFramework, withStyling } from "@ticore/metadata";
import PropTypes from "prop-types";
import { DYNAMIC_ANALYSIS_EMPTY_MESSAGES } from "../consts";

const RlCloudSandboxMitreAttack = ({
  attackData,
  responseTransformation = response => response,
  titaniumUI,
  useLatest,
  disablePopup,
  disableShowAll
}) => {
  return (
    <div className={"ticore-metadata"}>
      {attackData ? (
        <div>
          <AttackFramework
            attack={responseTransformation(attackData)}
            titaniumUI={titaniumUI}
            useLatest={useLatest}
            disablePopup={disablePopup}
            disableShowAll={disableShowAll}
          />
        </div>
      ) : (
        <b>{DYNAMIC_ANALYSIS_EMPTY_MESSAGES.mitre_attack}</b>
      )}
    </div>
  );
};

RlCloudSandboxMitreAttack.propTypes = {
  titaniumUI: PropTypes.bool,
  useLatest: PropTypes.bool,
  disablePopup: PropTypes.bool,
  disableShowAll: PropTypes.bool,
  responseTransformation: PropTypes.func,
  attackData: PropTypes.shape({})
};

export default withStyling(RlCloudSandboxMitreAttack);
